<template>
    <span class="interval">
        <div class="interval-label main-text-color" v-if="label">
            {{ $t(label) }}
        </div>
        <el-time-select
            :value="inputValue"
            class="interval-time-select"
            :placeholder="placeholder"
            @change="onChange"
            :disabled="disabled"
            :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '23:45'
            }"
        >
        </el-time-select>
    </span>
</template>

<script>
import { TimeSelect } from 'element-ui'

export default {
    components: {
        [TimeSelect.name]: TimeSelect, 
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: '' 
        },
        placeholder: {
            type: String,
            default: 'Time'
        },
        inputValue: {
            type: [Number, String]
        }
    },
    methods: {
        onChange (val) {
            const data = {
                value: val,
                component: this.$attrs
            }
            this.$emit('change', data)
        }
    }
};
</script>

<style lang="scss" scoped>
.interval-label {
    @apply mb-2;
}
[dir="rtl"] .interval-label {
    @apply ml-3;
}
[dir="ltr"] .interval-label {
    @apply mr-3;
}
.el-form-item__error {
    @apply pt-4;
}
.interval {
    @apply relative;
}
</style>

<style lang="scss">
.time-select .time-select-item.selected:not(.disabled) {
    @apply text-primary;
}
.time-select-item:hover {
    background: var(--mainBgColor-color);
}
.time-select-item {
    color: var(--mainTextColor-color);
    background: var(--secondaryBgColor-color);
}
</style>